import React from 'react'
import { global } from '../api/global'
import { FaPlay } from 'react-icons/fa' 

const fotourl = import.meta.env.VITE_FOTO || ''

function Canal({ item }) {
  const imageUrl = item.fototv 
    ? `${fotourl}/${item.fototv}.jpg` 
    : `${fotourl}/${item.fotoid}.jpg`

  return (
    <div className='group relative w-[140px] md:w-[200px] lg:w-[260px] cursor-pointer'>
      <div className="relative overflow-hidden rounded-lg aspect-video bg-surface shadow-lg transition-all duration-300 group-hover:shadow-glow group-hover:-translate-y-1">
        
        {/* Background Image */}
        <img 
          src={imageUrl} 
          alt={`Thumbnail for ${item.username}`}
          className='absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-110'
          loading="lazy"
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20" />

        {/* Play Icon 
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="p-4 bg-primary/70 rounded-full backdrop-blur-sm">
                <FaPlay className="text-white text-xl" />
            </div>
        </div> */}
        
        {/* Live Badge */}
        {item.online && (
          <div className="absolute top-2 right-2">
            <span className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-md animate-pulse">
              LIVE
            </span>
          </div>
        )}
      </div>
      
      <div className="mt-3">
        <h2 className='text-sm md:text-base font-semibold text-text truncate group-hover:text-primary transition-colors duration-300'>
          {item.username}
        </h2>
        <p className="text-xs md:text-sm text-text-subtle truncate">{item.estilo}</p>
      </div>
     
    </div>
  )
}

export default Canal